module.exports = __webpack_public_path__ + "images/emoji/tangerine.5e0ec74da8653a5425ed.png";